import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { apiError } from "@/lib/errors";

export default function ResetPasswordDialog({ target, onClose, onDone }) {
  const [pw, setPw] = useState("");
  const [force, setForce] = useState(true);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (pw.length < 6) return toast.error("Temporary password must be at least 6 characters");
    setSaving(true);
    try {
      await api.post(`/users/${target.id}/reset-password`, { temp_password: pw, force_change: force });
      toast.success(`Temporary password set for ${target.name}`);
      onDone(); onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="rounded-none border-2 border-[#0A1128] max-w-md" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">RESET PASSWORD</DialogTitle>
          <DialogDescription>Set a temporary password for <strong>{target.name}</strong> ({target.email}).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Temporary password</Label>
            <Input type="text" value={pw} onChange={e => setPw(e.target.value)} className="rounded-sm font-mono" data-testid="temp-password-input"/>
          </div>
          <label className="flex items-center gap-2 text-sm">
            <Checkbox checked={force} onCheckedChange={v => setForce(!!v)} data-testid="temp-password-force"/>
            Require a new password at next login
          </label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm">Cancel</Button>
          <Button onClick={save} disabled={saving} className="rounded-sm bg-[#0A1128] hover:bg-slate-800" data-testid="temp-password-save">
            {saving ? "Saving..." : "Set Password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
